import { render, staticRenderFns } from "./CommonHeaderV2SideMenu.vue?vue&type=template&id=58f3dff8&"
import script from "./CommonHeaderV2SideMenu.vue?vue&type=script&lang=js&"
export * from "./CommonHeaderV2SideMenu.vue?vue&type=script&lang=js&"
import style0 from "./CommonHeaderV2SideMenu.vue?vue&type=style&index=0&scope=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports